import React from 'react'
import { motion } from 'framer-motion'
import { Calendar, User, ArrowRight } from 'lucide-react'

const Blog = () => {
  const posts = [
    {
      title: 'The Future of Enterprise ERP Systems',
      excerpt: 'Exploring how AI and automation are reshaping enterprise resource planning...',
      author: 'Dark Tech Team',
      date: 'March 15, 2025',
      category: 'ERP',
      image: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '5 min read'
    },
    {
      title: 'Odoo vs Traditional ERP: A Comprehensive Comparison',
      excerpt: 'Understanding why businesses are migrating to Odoo for their ERP needs...',
      author: 'Dark Tech Team',
      date: 'March 10, 2025',
      category: 'Odoo',
      image: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '7 min read'
    },
    {
      title: 'Building Scalable SaaS Platforms in 2025',
      excerpt: 'Best practices for architecting multi-tenant applications that scale...',
      author: 'Dark Tech Team',
      date: 'March 5, 2025',
      category: 'SaaS',
      image: 'https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '6 min read'
    },
  ]

  return (
    <div className="min-h-screen pt-20" data-component-path="client/src/pages/Blog.jsx" data-component-line="1:1" data-component-id="client/src/pages/Blog.jsx:1:1">
      <section 
        className="relative min-h-[50vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-component-path="client/src/pages/Blog.jsx"
        data-component-line="2:3"
        data-component-id="client/src/pages/Blog.jsx:2:3"
      >
        <div className="absolute inset-0 bg-dark-primary/80" data-component-path="client/src/pages/Blog.jsx" data-component-line="10:5" data-component-id="client/src/pages/Blog.jsx:10:5"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Blog.jsx" data-component-line="12:5" data-component-id="client/src/pages/Blog.jsx:12:5">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            data-component-path="client/src/pages/Blog.jsx"
            data-component-line="13:7"
            data-component-id="client/src/pages/Blog.jsx:13:7"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6" data-component-path="client/src/pages/Blog.jsx" data-component-line="18:9" data-component-id="client/src/pages/Blog.jsx:18:9">
              Tech <span className="text-gradient" data-component-path="client/src/pages/Blog.jsx" data-component-line="19:19" data-component-id="client/src/pages/Blog.jsx:19:9">Insights</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-component-path="client/src/pages/Blog.jsx" data-component-line="21:9" data-component-id="client/src/pages/Blog.jsx:21:9">
              Expert perspectives on enterprise software, ERP, and digital transformation
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-dark-primary" data-component-path="client/src/pages/Blog.jsx" data-component-line="28:3" data-component-id="client/src/pages/Blog.jsx:28:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Blog.jsx" data-component-line="29:5" data-component-id="client/src/pages/Blog.jsx:29:5">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/Blog.jsx" data-component-line="30:7" data-component-id="client/src/pages/Blog.jsx:30:7">
            {posts.map((post, index) => (
              <motion.article
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="glass-panel rounded-xl overflow-hidden hover:neon-border transition-all group cursor-pointer"
                data-component-path="client/src/pages/Blog.jsx"
                data-component-line="32:11"
                data-component-id="client/src/pages/Blog.jsx:32:11"
              >
                <div className="relative h-56 overflow-hidden" data-component-path="client/src/pages/Blog.jsx" data-component-line="39:13" data-component-id="client/src/pages/Blog.jsx:39:13">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800'
                    }}
                    data-component-path="client/src/pages/Blog.jsx"
                    data-component-line="40:15"
                    data-component-id="client/src/pages/Blog.jsx:40:15"
                  />
                  <div className="absolute top-4 left-4" data-component-path="client/src/pages/Blog.jsx" data-component-line="51:15" data-component-id="client/src/pages/Blog.jsx:51:15">
                    <span className="px-3 py-1 bg-neon-green text-dark-primary text-xs font-semibold rounded-full" data-component-path="client/src/pages/Blog.jsx" data-component-line="52:17" data-component-id="client/src/pages/Blog.jsx:52:17">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6" data-component-path="client/src/pages/Blog.jsx" data-component-line="57:13" data-component-id="client/src/pages/Blog.jsx:57:13">
                  <h3 className="text-xl font-bold mb-3 text-white group-hover:text-neon-green transition-colors" data-component-path="client/src/pages/Blog.jsx" data-component-line="58:15" data-component-id="client/src/pages/Blog.jsx:58:15">
                    {post.title}
                  </h3>
                  <p className="text-gray-400 mb-4 line-clamp-2" data-component-path="client/src/pages/Blog.jsx" data-component-line="61:15" data-component-id="client/src/pages/Blog.jsx:61:15">{post.excerpt}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-component-path="client/src/pages/Blog.jsx" data-component-line="62:15" data-component-id="client/src/pages/Blog.jsx:62:15">
                    <div className="flex items-center gap-2" data-component-path="client/src/pages/Blog.jsx" data-component-line="63:17" data-component-id="client/src/pages/Blog.jsx:63:17">
                      <User className="w-4 h-4" data-component-path="client/src/pages/Blog.jsx" data-component-line="64:19" data-component-id="client/src/pages/Blog.jsx:64:19" />
                      <span data-component-path="client/src/pages/Blog.jsx" data-component-line="65:19" data-component-id="client/src/pages/Blog.jsx:65:19">{post.author}</span>
                    </div>
                    <div className="flex items-center gap-2" data-component-path="client/src/pages/Blog.jsx" data-component-line="67:17" data-component-id="client/src/pages/Blog.jsx:67:17">
                      <Calendar className="w-4 h-4" data-component-path="client/src/pages/Blog.jsx" data-component-line="68:19" data-component-id="client/src/pages/Blog.jsx:68:19" />
                      <span data-component-path="client/src/pages/Blog.jsx" data-component-line="69:19" data-component-id="client/src/pages/Blog.jsx:69:19">{post.date}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-component-path="client/src/pages/Blog.jsx" data-component-line="72:15" data-component-id="client/src/pages/Blog.jsx:72:15">
                    <span className="text-gray-500 text-sm" data-component-path="client/src/pages/Blog.jsx" data-component-line="73:17" data-component-id="client/src/pages/Blog.jsx:73:17">{post.readTime}</span>
                    <div className="flex items-center gap-2 text-neon-green font-semibold text-sm" data-component-path="client/src/pages/Blog.jsx" data-component-line="74:17" data-component-id="client/src/pages/Blog.jsx:74:17">
                      Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-component-path="client/src/pages/Blog.jsx" data-component-line="75:30" data-component-id="client/src/pages/Blog.jsx:75:30" />
                    </div>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Blog